import { z } from 'zod';
import { DateTimeUtcService } from '@mews-framework/datetime';
import { dateStringValidationError } from './common';

export const dateTimeUtcStringSchema = z.string().superRefine((value, ctx) => {
    if (!DateTimeUtcService.isValidString(value)) {
        ctx.addIssue(dateStringValidationError);
        return z.NEVER;
    }

    return value;
});
